import { graphql, useStaticQuery } from "gatsby"

export const usesAcnData = () => {
  const data = useStaticQuery(graphql`
    query {
      logos: allSanityMedia(filter: { tags: { in: "lender_logo" } }) {
        nodes {
          id
          label
          tags
          image_desktop {
            asset {
              gatsbyImageData(
                width: 500
                formats: [AUTO, WEBP]
                placeholder: BLURRED
              )
            }
          }
        }
      }
    }
  `)

  return data
}
